<template>
  <div class="workflow-page">
    <!-- 流程筛选卡片 -->
    <a-card class="filter-card" size="small">
      <workflow-filter-form :project-id="projectId" :filter="filterForm" @filter-change="handleFilterChange" @search="handleSearch" @reset="handleReset" />
    </a-card>
    <!-- 流程列表卡片 -->
    <a-card title="流程列表" class="list-card" size="small">
      <template slot="extra">
        <a-space>
          <workflow-view ref="view" @setFilter="setFilter" />
          <a-button v-tc="{ name: '添加流程' }" type="primary" icon="plus" @click="onAdd"> 添加流程 </a-button>
        </a-space>
      </template>
      <workflow-data-list category="workflow" :loading="loading" :table-data="tableData" :pagination="pagination" @page-change="handlePageChange" @search="getWorkFlowList" />
    </a-card>
  </div>
</template>

<script>
import { workflowList } from '@/api/project/workflow';

import WorkflowView from '@/pages/project/workflow/components/WorkflowView';
import WorkflowDataList from '@/pages/project/workflow/components/WorkflowDataList';
import WorkflowFilterForm from '@/pages/project/workflow/components/WorkflowFilterForm';

export default {
  name: 'WorkflowPage',
  components: {
    WorkflowView,
    WorkflowDataList,
    WorkflowFilterForm
  },
  data() {
    return {
      tableData: [],
      loading: false,
      workflowId: null,
      filterForm: this.getInitialFilterForm(),
      projectId: parseInt(this.$route.params.project_id) || null,
      pagination: {
        size: 'large',
        total: 0,
        current: parseInt(this.$route.query.page_number) || 1,
        pageSize: parseInt(this.$route.query.page_size) || this.$store.getters.pageSize,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100'],
        showTotal: total => `共 ${total} 条`
      }
    };
  },
  methods: {
    /**
     * 获取初始化筛选条件，页面刷新时根据当前路由参数计算
     */
    getInitialFilterForm() {
      return {
        project_id: parseInt(this.$route.params.project_id) || null,
        about: this.$route.query.about || 'all',
        title: this.$route.query.title || null,
        template_id: this.$route.query.template_id ? this.$route.query.template_id.split(',').map(item => parseInt(item)) : [],
        creator: this.$route.query.creator ? this.$route.query.creator.split(',').map(item => parseInt(item)) : [],
        status: this.$route.query.status ? this.$route.query.status.split(',').map(item => parseInt(item)) : [],
        team: parseInt(this.$route.query.team) || null,
        start_date: this.$route.query.start_date || null,
        end_date: this.$route.query.end_date || null,
        role: this.$route.query.role || 'DEV',
        users: this.$route.query.users ? this.$route.query.users.split(',').map(user => parseInt(user)) : [],
        steps: []
      };
    },

    /**
     * 查询流程列表数据
     */
    async getWorkFlowList() {
      this.loading = true;
      try {
        const res = await workflowList({
          ...this.filterForm,
          page_size: this.pagination.pageSize,
          page_number: this.pagination.current
        });
        this.tableData = res.data.items;
        this.pagination.total = res.data.total;
      } catch (error) {
        console.error('Failed to fetch workflow list:', error);
      } finally {
        this.loading = false;
      }
    },

    /**
     * 筛选项回调事件
     */
    handleFilterChange(filter) {
      this.filterForm = { ...filter };
      this.updateRoute();
      this.getWorkFlowList();
    },

    /**
     * 搜索事件回调
     * @param {*} filter
     */
    handleSearch(filter) {
      this.filterForm = { ...filter };
      this.updateRoute();
      this.getWorkFlowList();
    },

    /**
     * 重置筛选事件回调
     */
    handleReset() {
      this.pagination.current = 1;
      this.pagination.pageSize = this.$store.getters.pageSize;
      this.$nextTick(() => {
        this.$refs.view.resetView();
      });
      this.$router.push({ name: 'page:project:workflow:list' });
      this.filterForm = this.getInitialFilterForm();
      this.getWorkFlowList();
    },

    /**
     * 表格分页变更回调事件
     * @param {*} pagination
     */
    handlePageChange(pagination) {
      this.pagination = pagination;
      this.updateRoute();
      this.getWorkFlowList();
    },

    /**
     * 设置筛选条件，视图切换时调用该函数
     * @param {*} filter
     */
    setFilter(filter) {
      this.filterForm = {
        ...filter,
        role: filter.role || 'DEV',
        about: filter.about || 'all',
        project_id: this.projectId
      };
      this.pagination.pageSize = this.$store.getters.pageSize;
      this.pagination.current = 1;
      this.updateRoute();
      this.getWorkFlowList();
    },

    /**
     * 更新路由信息
     */
    updateRoute() {
      const query = {};
      Object.entries(this.filterForm).forEach(([key, value]) => {
        if (value !== null && value !== undefined) {
          if (Array.isArray(value)) {
            if (value.length > 0) {
              query[key] = value.join(',');
            }
          } else {
            query[key] = value;
          }
        }
      });
      this.$router.push({ name: 'page:project:workflow:list', query });
    },

    /**
     * 点击创建流程
     */
    onAdd() {
      this.$router.push({ name: 'page:project:workflow:create' });
    }
  }
};
</script>

<style lang="less" scoped>
.workflow-page {
  .filter-card {
    margin-bottom: 16px;
  }

  .list-card {
    :deep(.ant-card-head) {
      min-height: 48px;
      padding: 0 16px;
    }

    :deep(.ant-card-body) {
      padding: 16px;
    }
  }
}
</style>
